import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]

import NkGroup from '@/core/components/layout/Group/NkGroup.vue';
import { computed, inject } from 'vue';
import { formItemInjectionKey, FormItemInjection } from '@/core/components/forms/Form/form.shared'
import {v4 as uuid} from 'uuid'
import { StCheckbox } from './checkbox.styled';
import { props as propsDefinition } from './checkbox.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkCheckbox',
  props: propsDefinition,
  setup(__props) {

const props = __props


const injection = inject(formItemInjectionKey) as FormItemInjection
const id = computed(() => injection?.id || uuid())
const error = computed(() => !!(injection?.error.value) || props.error)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    for: _unref(id),
    class: "cursor-pointer"
  }, [
    _createVNode(NkGroup, { "no-wrap": "" }, {
      default: _withCtx(() => [
        _createVNode(_unref(StCheckbox), {
          id: _unref(id),
          name: _ctx.name,
          error: _unref(error),
          checked: _ctx.$props.modelValue,
          type: "checkbox",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !_ctx.$props.modelValue))),
          disabled: _ctx.$props.disabled,
          isDisabled: _ctx.$props.disabled
        }, null, 8, ["id", "name", "error", "checked", "disabled", "isDisabled"]),
        _createElementVNode("span", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    })
  ], 8, _hoisted_1))
}
}

})